import React from "react";
import PropTypes from "prop-types";

export function Board(props) {
  const renderCanvas = () => {
    if (props.switchedOn) {
      return props.children;
    } else {
      return <div style={props.style.canvas} />;
    }
  };

  return (
    <div style={props.style.board}>
      <div style={props.style.board_content}>{renderCanvas()}</div>
    </div>
  );
}

Board.propTypes = {
  /**
   * style to set for each tags in the component
   */
  style: PropTypes.object,
  /**
   * Boolean to check if switch is ON/OFF
   */
  switchedOn: PropTypes.bool,
  /**
   * Component to be displayed on board
   */
  children: PropTypes.element,
};
